import React from 'react';

interface DecimalFieldProps {
  id: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  decimalPlaces?: number;
}

const DecimalField: React.FC<DecimalFieldProps> = ({
  id,
  value,
  onChange,
  placeholder,
  disabled,
  min,
  max,
  step = 0.0000001,
  decimalPlaces = 7,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (inputValue === '' || inputValue === '-') {
      onChange(e);
      return;
    }

    const decimalRegex = /^-?\d*\.?\d*$/;
    if (decimalRegex.test(inputValue)) {
      const parts = inputValue.split('.');
      if (parts.length === 2 && parts[1].length > decimalPlaces) {
        return;
      }

      const numValue = parseFloat(inputValue);
      if (!Number.isNaN(numValue)) {
        if (
          (min !== undefined && numValue < min) ||
          (max !== undefined && numValue > max)
        ) {
          return;
        }
      }

      onChange(e);
    }
  };

  return (
    <input
      type="text"
      id={id}
      value={value ?? ''}
      onChange={handleChange}
      placeholder={placeholder}
      className="h-10 w-full rounded-md border border-gray-300 px-4 text-sm text-ink outline-none transition-colors placeholder:text-ink-muted focus:border-primary focus:ring-2 focus:ring-primary/30 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-ink-muted dark:border-white/20 dark:bg-white/5 dark:text-white dark:placeholder:text-white/40 dark:focus:border-primary"
      disabled={disabled}
      inputMode="decimal"
      data-type="decimal"
      step={step}
    />
  );
};

export default DecimalField;
